export interface TransportReturnContext { orderId: string; }
export function readTransportReturnContext(search: URLSearchParams): TransportReturnContext | null {
  const orderId = search.get('returnToOrderId');
  return orderId ? { orderId } : null;
}
export function buildOrderTransportPath(orderId: string): string { return `/app/orders/${encodeURIComponent(orderId)}?tab=transport`; }
export function withTransportReturnContext(path: string, orderId: string | null | undefined): string {
  if (!orderId) return path;
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}returnToOrderId=${encodeURIComponent(orderId)}`;
}
